import styled from "styled-components"
import Grid from "./grid"

export const Container = styled(Grid.Item)``
Container.defaultProps = {
  gridColumn: "legal-start / legal-end",
}
